require('./payrollLoanRequestNewStepFour.scss');

// @vendor
const React = require('react');

// @commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');


// @components
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

//@utilities
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');

//@constants
const { OKButton } = require('components/commons/OKButton/OKButton');
const { INE_DOCUMENT, CONTRACT_DOCUMENT, INE_DOCUMENT_NAME, YES, NO } = require('../../../../../loansConstants/index');
const translationContractLoanPdfViewerINE = require('../../../contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const download = require('downloadjs');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
class PayrollLoanRequestNewStepFour extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnPrintDocument = this.handleOnPrintDocument.bind(this);
        this.handleOnDownloadDocument = this.handleOnDownloadDocument.bind(this);
        this.handleAgreeCheckModal = this.handleAgreeCheckModal.bind(this);
        this.handleCheckRadioButton = this.handleCheckRadioButton.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);

    }
    buildLinkButtonMessage(docType, documentName) {
        return (
            <OKButton
                onClick={event => this.handleCheckboxDownloadEvents(event, docType)}
                modifier="link-emphasize"
                autoHeight
                loading={false}
            >
                {documentName}
            </OKButton>
        )
    }
    handleDocumentReaded() {
        const { checkReadDocument } = this.props;
        checkReadDocument()
    }
    handleOnDownloadDocument() {
        const { immPayrollLoanRequest } = this.props;
        const document = immPayrollLoanRequest.get('filePayrollLoanINEDocument');
        download(document, INE_DOCUMENT_NAME, 'application/pdf');

    }
    handleOnPrintDocument() {
        const { immPayrollLoanRequest, printDocumentOffice } = this.props;
        const document = immPayrollLoanRequest.get('filePayrollLoanINEDocument');
        if (document) {
            openBase64pdfInPrintWindow(document);
        }
        if (isPrintOfficeMode()) {
            printDocumentOffice()
        }
    }
    handleCheckRadioButton(check) {
        const { checkRadioButtonOffice, checkCheckedDocument } = this.props;
        if (check === YES) {
            checkRadioButtonOffice(true)
            checkCheckedDocument(false)
        } else {
            checkRadioButtonOffice(false)
            checkCheckedDocument(true)
        }
    }
    handleAgreeCheckModal() {
        const { checkCheckedDocument, immPayrollLoanRequest } = this.props;
        const agreeIneCheckbox = immPayrollLoanRequest.get('agreeIneCheckbox')
        checkCheckedDocument(agreeIneCheckbox)
    }
    buildCheckboxLabel(poeditorPrefix) {
        const getPoEditorKey = key => {
            return `${poeditorPrefix}-${poeditorPrefix}_${key}`;
        };
        const splitMessage = formatText(getPoEditorKey(`contractRetailLoanAgreeCheckboxLabel`)).split('%s');

        const injectedLinks = [
            { docType: INE_DOCUMENT, text: getPoEditorKey('contractRetailLoanIneDocument') },
            { docType: CONTRACT_DOCUMENT, text: getPoEditorKey('contractRetailLoanContractDocument') },
        ];

        const message = splitMessage.map((message, index) => {
            const link = injectedLinks[index];
            const documentName = link ? formatText(link.text) : '';
            const replacement = link ? this.buildLinkButtonMessage(link.docType, documentName) : '';

            return (
                <span key={index}>
                    {message}
                    {replacement}
                </span>
            );
        });

        return <span>{message}</span>;
    }
    buildCheckbox() {
        const {
            validate,
            immPayrollLoanRequest
        } = this.props;
        const checkboxFlag = immPayrollLoanRequest.get('checkboxFlag');
        const errorLoading = immPayrollLoanRequest.get('errorEasyLoanIneDocument')
        const agreeIneCheckbox = immPayrollLoanRequest.get('agreeIneCheckbox')
        const errorState = (validate && !agreeIneCheckbox);
        const errorMessage = formatText('contractEasyLoanStepThree-checkboxErrorMessage');
        const isPayrollLoanEmailSent = immPayrollLoanRequest.get('isPayrollLoanEmailSent');

        const checkbox = (
            <div>
                <OKCheckbox
                    extraClass="contract-loan-pdf-viewer__checkbox"
                    disabled={checkboxFlag || __CONTACT_CENTER__ && !isPayrollLoanEmailSent}
                    errorMessage={errorMessage}
                    errorState={errorState}
                    idName="contract-loan-pdf-viewer-checkbox"
                    label={<FormattedText value={translationContractLoanPdfViewerINE.PDF_CHECKBOX} />}
                    onChange={this.handleAgreeCheckModal}
                    value={agreeIneCheckbox || checkboxFlag}
                />
            </div>
        )

        return !errorLoading || checkboxFlag ? checkbox : null;
    }
    buildContent() {
        const { immPayrollLoanRequest } = this.props;

        const documents = immPayrollLoanRequest.get('filePayrollLoanINEDocument');
        const scrollDown = immPayrollLoanRequest.get('scrollDown')
        const poeditorPrefix = 'contractRetailLoanStepThree';
        const title = formatText(`${poeditorPrefix}-${poeditorPrefix}_title`);
        const checkbox = scrollDown && this.buildCheckbox();

        return (
            <div className="col-xs-12">
                <div className="retail-loan-step-three__content">
                    <hr />
                    <OKPdfViewer
                        title={title}
                        onDownload={() => this.handleOnDownloadDocument()}
                        onPrint={this.handleOnPrintDocument}
                        pdfFile={documents}
                        displayScrollButton
                        scale={1}
                        infiniteScroll={false}
                        onDocumentReaded={this.handleDocumentReaded}
                    />
                    {checkbox}

                </div>
            </div>
        );
    }
    buildContentCC() {
        const { immPayrollLoanRequest,
            immProfile,
            preContractualMail,
            requestProfile,
            sendMail,
            sendEasyLoanSimpleEmail
        } = this.props;


        const clientEmail = PersonalDataHelper.getEmail(immProfile);
        const refreshEmailError = immPayrollLoanRequest.get('error');
        const filePayrollLoanINEDocumentSuccess = immPayrollLoanRequest.get('filePayrollLoanINEDocumentSuccess');
        const information = formatText('contractEasyLoanTypeCStepTwo-legalInfoText');
        const checkbox = this.buildCheckbox();

        return (
            <div className="col-xs-12">
                <div className="retail-loan-step-three__content">
                    <div className="contract-easy-loan-typec-document-step__blockView">
                        <div className="contract-easy-loan-typec-document-step__subtitle">
                            <FormattedText value="contractEasyLoanTypeCStepTwo-blockHeadingTitle" />
                        </div>
                        <BlockInfo extraClass="contract-payroll-loan-step-two__block-check" hasCheckbox>
                            <FormattedText value="payrollLoanRequest-personalLoanRequestStepTwoFooter" />

                        </BlockInfo>
                    </div>
                    <PreContractualMailInfo
                        email={clientEmail}
                        preContractualMail={preContractualMail}
                        profileError={refreshEmailError}
                        requestProfile={requestProfile}
                        sendEmail={sendMail}
                        showLegalText={false}
                        legalInfoText={false}
                        sendSimpleEmail={sendEasyLoanSimpleEmail}
                        mainFlag={'EASY_LOAN_TYPEC'}
                        contractObj={immPayrollLoanRequest}
                        loadingSendButton={!filePayrollLoanINEDocumentSuccess}

                    />
                    {checkbox}

                    <div className="contract-easy-loan-typec-document-step__information">
                        <i className="icon-informacion"></i>
                        {information}
                    </div>
                </div>
            </div>
        );
    }
    buildRadioButton() {
        const { immPayrollLoanRequest } = this.props;
        const payrolLoanRequestPrintedDocument = immPayrollLoanRequest.get('payrollLoanRequestPrintedDocument');
        return (
            <div className="mortgage-request-holder-radio-button">
                <p>{formatText(`hireCardtStep-titleOfficeRadio`)}</p>
                <RadioButtonGroup
                    onChange={this.handleCheckRadioButton}
                    selectedValue={payrolLoanRequestPrintedDocument === null ? '' : payrolLoanRequestPrintedDocument ? YES : NO}
                    idPrefix="newRadioPrintedDocument"
                    isHorizontal={false}
                    name="newRadioPrintedDocument">
                    <RadioButton label={formatText('officePrinter-yesRadioOption')} value={YES} className="signature-pattern__printed-documents-radio" />
                    <RadioButton label={formatText('officePrinter-noRadioOption')} value={NO} className="signature-pattern__printed-documents-radio" />
                </RadioButtonGroup>
            </div>
        )
    }
    buildContentOfficine() {
        const { immPayrollLoanRequest } = this.props;

        const documents = immPayrollLoanRequest.get('filePayrollLoanINEDocument');
        const payrollLoanRequestShowRadioButtons = immPayrollLoanRequest.get('payrollLoanRequestShowRadioButtons');
        const poeditorPrefix = 'contractRetailLoanStepThree';
        const title = formatText(`${poeditorPrefix}-${poeditorPrefix}_title`);
        const radioButtons = this.buildRadioButton();
        return (
            <div className="col-xs-12">
                <div className="retail-loan-step-three__content">
                    <BlockInfo extraClass="contract-payroll-loan-step-two__block-check" hasCheckbox>
                        <FormattedText value="ineBlockTitle-contractEasyLoanStepThree" />
                    </BlockInfo>
                    <hr />
                    <OKPdfViewer
                        title={title}
                        onDownload={() => this.handleOnDownloadDocument()}
                        onPrint={this.handleOnPrintDocument}
                        pdfFile={documents}
                        displayScrollButton
                        scale={1}
                        infiniteScroll={false}
                        onDocumentReaded={this.handleDocumentReaded}
                    />
                    {payrollLoanRequestShowRadioButtons &&
                        radioButtons
                    }

                </div>
            </div>
        );
    }
    buildTitle() {
        const other = (
            <React.Fragment>
                <div className="retail-loan-step-three__title">
                    <FormattedText value="contractRetailLoanStepThree-title" />
                </div>
                <div className="retail-loan-step-three__subtitle">
                    <FormattedText value="contractEasyLoanTypeC-step2Label" />
                </div>
            </React.Fragment>
        )
        return other;
    }
    render() {
        const content = this.buildContent();
        const contentCC = this.buildContentCC();
        const contentOffice = this.buildContentOfficine();
        const title = this.buildTitle();
        return (
            <div className="retail-loan-step-three">
                {title}
                <div className="row">
                    {!__CONTACT_CENTER__ && !isPrintOfficeMode() ? content : null}
                    {__CONTACT_CENTER__ && !isPrintOfficeMode() ? contentCC : null}
                    {__CONTACT_CENTER__ && isPrintOfficeMode() ? contentOffice : null}

                </div>
            </div>
        );
    }
}



module.exports = PayrollLoanRequestNewStepFour;
